export const login = state => state.login
export const update = state => state.update
export const lists = state => state.list.lists
export const banks = state => state.list.banks
export const branches = state => state.list.branches
export const versions = state => state.list.versions
// export const version = state => state.item.version
export const versionsAgreements = state => state.list.versionsAgreements
export const versionsAgreement = state => state.list.versionsAgreement
export const max = state => state.max
export const sum = state => state.sum
export const count = state => state.count
export const layout = state => state.layout
export const digestibility = state => state.digestibility
export const aggregate_appointment = state => state.item.aggregate_appointment
export const aggregate_appointment_month = state => state.item.aggregate_appointment_month
export const aggregate_appointment_month_comparison = state => state.item.aggregate_appointment_month_comparison
export const aggregate_appointment_month2 = state => state.item.aggregate_appointment_month2
export const aggregate_appointment_month2_comparison = state => state.item.aggregate_appointment_month2_comparison
export const aggregate_contract = state => state.item.aggregate_contract
export const aggregate_agreement = state => state.item.aggregate_agreement
export const aggregate_contract_month = state => state.item.aggregate_contract_month
export const aggregate_paymentdetail = state => state.item.aggregate_paymentdetail
export const aggregate_tutor_channel = state => state.item.aggregate_tutor_channel
export const documents = state => state.list.documents
export const document = state => state.item.document
export const users = state => state.list.users
export const user = state => state.item.user
export const companies = state => state.list.companies
export const company = state => state.item.company
export const offices = state => state.list.offices
export const office = state => state.item.office
export const prefs = state => state.list.prefs
export const pref = state => state.item.pref
export const families = state => state.list.families
export const family = state => state.item.family
export const familysupports = state => state.list.familysupports
export const familysupport = state => state.item.familysupport
export const familyfiles = state => state.list.familyfiles
export const familyfile = state => state.item.familyfile
export const students = state => state.list.students
export const student = state => state.item.student
export const student_tutors = state => state.list.student_tutors
export const student_tutor = state => state.item.student_tutor
export const studentfiles = state => state.list.studentfiles
export const studentfile = state => state.item.studentfile
export const tutors = state => state.list.tutors
export const tutor = state => state.item.tutor
export const tutorsupports = state => state.list.tutorsupports
export const tutorsupport = state => state.item.tutorsupport
export const tutorfiles = state => state.list.tutorfiles
export const tutorfile = state => state.item.tutorfile
export const reports = state => state.list.reports
export const report = state => state.item.report
export const tags = state => state.list.tags
export const tag = state => state.item.tag
export const support_tags = state => state.list.support_tags
export const support_tag = state => state.item.support_tag
export const channels = state => state.list.channels
export const channel = state => state.item.channel
export const office_channels = state => state.list.office_channels
export const office_channel = state => state.item.office_channel
export const appointment_channels = state => state.list.appointment_channels
export const appointment_channel = state => state.item.appointment_channel
export const tutor_channels = state => state.list.tutor_channels
export const tutor_channel = state => state.item.tutor_channel
export const nexts = state => state.list.nexts
export const appointments = state => state.list.appointments
export const appointment = state => state.item.appointment
export const todos = state => state.list.todos
export const todo = state => state.item.todo
export const conditions = state => state.list.conditions
export const condition = state => state.item.condition
export const student_conditions = state => state.list.student_conditions
export const student_condition = state => state.item.student_condition
export const tutor_conditions = state => state.list.tutor_conditions
export const tutor_condition = state => state.item.tutor_condition
export const agreements = state => state.list.agreements
export const agreement = state => state.item.agreement
export const agreementsupports = state => state.list.agreementsupports
export const agreementsupport = state => state.item.agreementsupport
export const advisors = state => state.list.advisors
export const advisor = state => state.item.advisor

export const contracts = state => state.list.contracts
export const contract = state => state.item.contract
export const paymentdetails = state => state.list.paymentdetails
export const paymentdetail = state => state.item.paymentdetail
export const paymentdetailsDelinquent_month = state => state.list.paymentdetailsDelinquent_month
export const paymentdetailsDelinquent_two_month = state => state.list.paymentdetailsDelinquent_two_month
export const paymentdetails2s = state => state.list.paymentdetails2s
export const paymentdetails2 = state => state.item.paymentdetails2
export const paymentdetails2sDelinquent_month = state => state.list.paymentdetails2sDelinquent_month
export const paymentdetails2sDelinquent_two_month = state => state.list.paymentdetails2sDelinquent_two_month

import config from '@/settings/config.js'

export function getAPIURL () {
  let URL = config['production'].url
  if (process.env.NODE_ENV === 'development') {
    URL = config['development'].url
  }
  return URL
}

export function getFILE () {
  let FILE = config['production'].pdf
  if (process.env.NODE_ENV === 'development') {
    FILE = config['development'].pdf
  }
  return FILE
}



// WEBPACK FOOTER //
// ./src/store/getters.js